import React from 'react';
import './styles/Header.css';

const Header = ({ onMenuToggle, currentBoardNum, subtitle }) => {
    const displaySubtitle = subtitle ?? (currentBoardNum ? `Board #${currentBoardNum}` : null);
    return (
        <header className="header-row">
            <div className="header-title-group">
                <h1 className="header-title">The Combos</h1>
                {displaySubtitle ? <p className="header-subtitle">{displaySubtitle}</p> : null}
            </div>
            <button className="header-hamburger" onClick={onMenuToggle} aria-label="Open board menu">
                <span />
                <span />
                <span />
            </button>
        </header>
    );
};

export default Header;